/*
 * @Descripttion: 
 * @version: V1.0.0
 * @Author: zym
 * @Date: 2023-10-16 10:31:06
 */

export default class BaseUtil {/**
   * @name: 获取url中的参数(参数名为key,参数值为value)
   */
  static getRequestParams() {
    let url = window.location.search
    let theRequest = {}
    if (url.indexOf('?') !== -1) {
      let str = url.substr(1)
      let strs = str.split('&')
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = (strs[i].split('=')[1])
      }
    }
    return theRequest
  }

  static getUniqueId() {
    let date = new Date()
    let year = date.getFullYear().toString()
    let month = (date.getMonth() + 1).toString().padStart(2, '0')
    let day = date.getDate().toString().padStart(2, '0')
    let hour = date.getHours().toString().padStart(2, '0')
    let minute = date.getMinutes().toString().padStart(2, '0')
    let second = date.getSeconds().toString().padStart(2, '0')
    let Milliseconds = date.getMilliseconds().toString().padStart(3, '0')
    let dateTime = year + month + day + hour + minute + second + Milliseconds

    return dateTime + this.randomn(8)
  }

  static randomn(n) {
    if (n > 21) return null
    var re = new RegExp('(\\d{' + n + '})(\\.|$)')
    var num = (Array(n - 1).join(0) + Math.pow(10, n) * Math.random()).match(re)[1]
    return num
  }

  /**
   * @name: 时间戳转换成指定格式日期
   * @param timestamp 时间戳
   * @param formats 格式
   */
  static dateFormt(timestamp, formats) {
    // formats格式包括
    // 1. Y-m-d
    // 2. Y-m-d H:i:s
    // 3. Y年m月d日
    // 4. Y年m月d日 H时i分
    formats = formats || 'Y-m-d'

    let zero = function(value) {
      if (value < 10) {
        return '0' + value
      }
      return value
    }

    if (timestamp && String(timestamp).indexOf('-') != -1) {
      timestamp = timestamp.replace(/-/g, '/')
    }

    let myDate = timestamp ? new Date(timestamp) : new Date()

    let year = myDate.getFullYear()
    let month = zero(myDate.getMonth() + 1)
    let day = zero(myDate.getDate())

    let hour = zero(myDate.getHours())
    let minite = zero(myDate.getMinutes())
    let second = zero(myDate.getSeconds())

    return formats.replace(/Y|m|d|H|i|s/ig, function(matches) {
      return ({
        Y: year,
        m: month,
        d: day,
        H: hour,
        i: minite,
        s: second
      })[matches]
    })
  }

  static isWxplatform() {
    return navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'
  }
}